import { RouterProvider } from 'react-router-dom';

import { router } from './util/route/route';

import FallbackLoader from './component/ContentWrapper/Content/Loader/FallbackLoader';
import { useIsMobile } from './hook/useIsMobile';

import './theme/theme-light.css';
import './theme/theme-dark.css';
import { useEffect } from 'react';
import { useAppSelector } from './hook/useAppSelector';
import { applyTheme } from './theme/applyTheme';
import { getThemeFromPlatform } from './util/platform';
import { useUsernameFromAccessToken } from './hook/useUsernameFromAccessToken';

const App: React.FC = () => {
  useEffect(() => {
    const isCleanLayout = process.env.REACT_APP_IS_CLEAN_LAYOUT === 'true';

    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;

    if (favicon) {
      favicon.href = isCleanLayout ? 'data:,' : `${process.env.PUBLIC_URL}/favicon.ico`;
    }

    const appleIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement;

    if (appleIcon) {
      appleIcon.href = isCleanLayout ? 'data:,' : `${process.env.PUBLIC_URL}/favicon.ico`;
    }
  }, []);

  useIsMobile();
  useUsernameFromAccessToken();

  const theme = useAppSelector((state) => state.configSlice.theme);
  const themesByPlatform = useAppSelector((state) => state.configSlice.themesByPlatform);

  useEffect(() => {
    const selectedTheme = getThemeFromPlatform(themesByPlatform) || theme;
    applyTheme(selectedTheme);
  }, [theme, themesByPlatform]);

  return (
    <>
      <RouterProvider router={router} fallbackElement={<FallbackLoader></FallbackLoader>}></RouterProvider>
    </>
  );
};

export default App;
